export default __webpack_public_path__ + "assets/partly-cloudy-night-smoke.cd142d5c.svg";